import React, { useEffect, useMemo, useState } from "react";
import { Chart } from "@highcharts/react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import { Card, CardHeader, CardBody } from "./../../components/card/card.jsx";
import "bootstrap-daterangepicker/daterangepicker.css";
import "moment/locale/es";

Moment.locale("es");

function CreateChart() {
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    startDate: Moment().startOf("year").format("YYYY-MM-DD"),
    endDate: Moment().endOf("year").format("YYYY-MM-DD"),
  });

  const allDemoData = useMemo(() => {
    return [
      {
        id: 1,
        fecha: "2026-01-05",
        agencia: "Nissan Puebla",
        asesor: "Carlos Méndez",
        financiera: "NR Finance",
        concepto: "Accesorios",
        facturado: 185000,
        ubConBonos: 138000,
        ubSinBonos: 47000,
        autosVendidos: 1,
        ticketConBonos: 185000,
        ticketSinBonos: 162000,
      },
      {
        id: 2,
        fecha: "2026-01-14",
        agencia: "Nissan Cholula",
        asesor: "Ana López",
        financiera: "BBVA",
        concepto: "Garantías",
        facturado: 142000,
        ubConBonos: 103000,
        ubSinBonos: 39000,
        autosVendidos: 1,
        ticketConBonos: 142000,
        ticketSinBonos: 126000,
      },
      {
        id: 3,
        fecha: "2026-01-25",
        agencia: "Nissan San Manuel",
        asesor: "Jorge Ramírez",
        financiera: "Santander",
        concepto: "Seguros",
        facturado: 198000,
        ubConBonos: 146000,
        ubSinBonos: 52000,
        autosVendidos: 1,
        ticketConBonos: 198000,
        ticketSinBonos: 175000,
      },
      {
        id: 4,
        fecha: "2026-02-03",
        agencia: "Nissan Puebla",
        asesor: "Fernanda Cruz",
        financiera: "NR Finance",
        concepto: "Bonos",
        facturado: 176000,
        ubConBonos: 132000,
        ubSinBonos: 44000,
        autosVendidos: 1,
        ticketConBonos: 176000,
        ticketSinBonos: 158000,
      },
      {
        id: 5,
        fecha: "2026-02-11",
        agencia: "Nissan Atlixco",
        asesor: "Luis Herrera",
        financiera: "Banorte",
        concepto: "Accesorios",
        facturado: 154000,
        ubConBonos: 112000,
        ubSinBonos: 42000,
        autosVendidos: 1,
        ticketConBonos: 154000,
        ticketSinBonos: 141000,
      },
      {
        id: 6,
        fecha: "2026-02-24",
        agencia: "Nissan Cholula",
        asesor: "Carlos Méndez",
        financiera: "BBVA",
        concepto: "Garantías",
        facturado: 205000,
        ubConBonos: 151000,
        ubSinBonos: 54000,
        autosVendidos: 1,
        ticketConBonos: 205000,
        ticketSinBonos: 182000,
      },
      {
        id: 7,
        fecha: "2026-03-04",
        agencia: "Nissan Puebla",
        asesor: "Ana López",
        financiera: "NR Finance",
        concepto: "Servicios",
        facturado: 214000,
        ubConBonos: 156000,
        ubSinBonos: 58000,
        autosVendidos: 1,
        ticketConBonos: 214000,
        ticketSinBonos: 190000,
      },
      {
        id: 8,
        fecha: "2026-03-16",
        agencia: "Nissan San Manuel",
        asesor: "Jorge Ramírez",
        financiera: "Santander",
        concepto: "Accesorios",
        facturado: 189000,
        ubConBonos: 139000,
        ubSinBonos: 50000,
        autosVendidos: 1,
        ticketConBonos: 189000,
        ticketSinBonos: 171000,
      },
      {
        id: 9,
        fecha: "2026-03-28",
        agencia: "Nissan Texmelucan",
        asesor: "Daniela Soto",
        financiera: "Contado",
        concepto: "Seguros",
        facturado: 166000,
        ubConBonos: 120000,
        ubSinBonos: 46000,
        autosVendidos: 1,
        ticketConBonos: 166000,
        ticketSinBonos: 151000,
      },
      {
        id: 10,
        fecha: "2026-04-06",
        agencia: "Nissan Cholula",
        asesor: "Fernanda Cruz",
        financiera: "NR Finance",
        concepto: "Garantías",
        facturado: 223000,
        ubConBonos: 164000,
        ubSinBonos: 59000,
        autosVendidos: 1,
        ticketConBonos: 223000,
        ticketSinBonos: 201000,
      },
      {
        id: 11,
        fecha: "2026-04-18",
        agencia: "Nissan Puebla",
        asesor: "Carlos Méndez",
        financiera: "BBVA",
        concepto: "Bonos",
        facturado: 241000,
        ubConBonos: 177000,
        ubSinBonos: 64000,
        autosVendidos: 1,
        ticketConBonos: 241000,
        ticketSinBonos: 215000,
      },
      {
        id: 12,
        fecha: "2026-04-27",
        agencia: "Nissan Atlixco",
        asesor: "Luis Herrera",
        financiera: "Banorte",
        concepto: "Accesorios",
        facturado: 158000,
        ubConBonos: 115000,
        ubSinBonos: 43000,
        autosVendidos: 1,
        ticketConBonos: 158000,
        ticketSinBonos: 144000,
      },
      {
        id: 13,
        fecha: "2026-05-05",
        agencia: "Nissan San Manuel",
        asesor: "Ana López",
        financiera: "Santander",
        concepto: "Servicios",
        facturado: 208000,
        ubConBonos: 152000,
        ubSinBonos: 56000,
        autosVendidos: 1,
        ticketConBonos: 208000,
        ticketSinBonos: 186000,
      },
      {
        id: 14,
        fecha: "2026-05-14",
        agencia: "Nissan Cholula",
        asesor: "Jorge Ramírez",
        financiera: "NR Finance",
        concepto: "Garantías",
        facturado: 232000,
        ubConBonos: 170000,
        ubSinBonos: 62000,
        autosVendidos: 1,
        ticketConBonos: 232000,
        ticketSinBonos: 208000,
      },
      {
        id: 15,
        fecha: "2026-05-25",
        agencia: "Nissan Puebla",
        asesor: "Carlos Méndez",
        financiera: "NR Finance",
        concepto: "Accesorios",
        facturado: 249000,
        ubConBonos: 182000,
        ubSinBonos: 67000,
        autosVendidos: 1,
        ticketConBonos: 249000,
        ticketSinBonos: 223000,
      },
      {
        id: 16,
        fecha: "2026-06-03",
        agencia: "Nissan Texmelucan",
        asesor: "Daniela Soto",
        financiera: "Contado",
        concepto: "Seguros",
        facturado: 171000,
        ubConBonos: 125000,
        ubSinBonos: 46000,
        autosVendidos: 1,
        ticketConBonos: 171000,
        ticketSinBonos: 154000,
      },
      {
        id: 17,
        fecha: "2026-06-12",
        agencia: "Nissan Puebla",
        asesor: "Fernanda Cruz",
        financiera: "BBVA",
        concepto: "Bonos",
        facturado: 261000,
        ubConBonos: 191000,
        ubSinBonos: 70000,
        autosVendidos: 1,
        ticketConBonos: 261000,
        ticketSinBonos: 235000,
      },
      {
        id: 18,
        fecha: "2026-06-24",
        agencia: "Nissan Atlixco",
        asesor: "Luis Herrera",
        financiera: "Banorte",
        concepto: "Accesorios",
        facturado: 163000,
        ubConBonos: 118000,
        ubSinBonos: 45000,
        autosVendidos: 1,
        ticketConBonos: 163000,
        ticketSinBonos: 147000,
      },
      {
        id: 19,
        fecha: "2026-07-02",
        agencia: "Nissan Cholula",
        asesor: "Ana López",
        financiera: "NR Finance",
        concepto: "Garantías",
        facturado: 238000,
        ubConBonos: 174000,
        ubSinBonos: 64000,
        autosVendidos: 1,
        ticketConBonos: 238000,
        ticketSinBonos: 212000,
      },
      {
        id: 20,
        fecha: "2026-07-15",
        agencia: "Nissan San Manuel",
        asesor: "Jorge Ramírez",
        financiera: "Santander",
        concepto: "Servicios",
        facturado: 216000,
        ubConBonos: 158000,
        ubSinBonos: 58000,
        autosVendidos: 1,
        ticketConBonos: 216000,
        ticketSinBonos: 194000,
      },
      {
        id: 21,
        fecha: "2026-07-27",
        agencia: "Nissan Puebla",
        asesor: "Carlos Méndez",
        financiera: "NR Finance",
        concepto: "Accesorios",
        facturado: 273000,
        ubConBonos: 199000,
        ubSinBonos: 74000,
        autosVendidos: 1,
        ticketConBonos: 273000,
        ticketSinBonos: 246000,
      },
      {
        id: 22,
        fecha: "2026-08-06",
        agencia: "Nissan Cholula",
        asesor: "Fernanda Cruz",
        financiera: "BBVA",
        concepto: "Bonos",
        facturado: 228000,
        ubConBonos: 166000,
        ubSinBonos: 62000,
        autosVendidos: 1,
        ticketConBonos: 228000,
        ticketSinBonos: 205000,
      },
      {
        id: 23,
        fecha: "2026-08-17",
        agencia: "Nissan Texmelucan",
        asesor: "Daniela Soto",
        financiera: "Contado",
        concepto: "Seguros",
        facturado: 177000,
        ubConBonos: 129000,
        ubSinBonos: 48000,
        autosVendidos: 1,
        ticketConBonos: 177000,
        ticketSinBonos: 159000,
      },
      {
        id: 24,
        fecha: "2026-08-26",
        agencia: "Nissan Puebla",
        asesor: "Ana López",
        financiera: "NR Finance",
        concepto: "Garantías",
        facturado: 284000,
        ubConBonos: 207000,
        ubSinBonos: 77000,
        autosVendidos: 1,
        ticketConBonos: 284000,
        ticketSinBonos: 256000,
      },
      {
        id: 25,
        fecha: "2026-09-04",
        agencia: "Nissan Atlixco",
        asesor: "Luis Herrera",
        financiera: "Banorte",
        concepto: "Accesorios",
        facturado: 169000,
        ubConBonos: 121000,
        ubSinBonos: 48000,
        autosVendidos: 1,
        ticketConBonos: 169000,
        ticketSinBonos: 152000,
      },
      {
        id: 26,
        fecha: "2026-09-12",
        agencia: "Nissan San Manuel",
        asesor: "Jorge Ramírez",
        financiera: "Santander",
        concepto: "Servicios",
        facturado: 221000,
        ubConBonos: 161000,
        ubSinBonos: 60000,
        autosVendidos: 1,
        ticketConBonos: 221000,
        ticketSinBonos: 198000,
      },
      {
        id: 27,
        fecha: "2026-09-24",
        agencia: "Nissan Cholula",
        asesor: "Carlos Méndez",
        financiera: "NR Finance",
        concepto: "Bonos",
        facturado: 246000,
        ubConBonos: 179000,
        ubSinBonos: 67000,
        autosVendidos: 1,
        ticketConBonos: 246000,
        ticketSinBonos: 222000,
      },
      {
        id: 28,
        fecha: "2026-10-05",
        agencia: "Nissan Puebla",
        asesor: "Fernanda Cruz",
        financiera: "BBVA",
        concepto: "Garantías",
        facturado: 291000,
        ubConBonos: 212000,
        ubSinBonos: 79000,
        autosVendidos: 1,
        ticketConBonos: 291000,
        ticketSinBonos: 262000,
      },
      {
        id: 29,
        fecha: "2026-10-14",
        agencia: "Nissan Atlixco",
        asesor: "Daniela Soto",
        financiera: "Contado",
        concepto: "Seguros",
        facturado: 181000,
        ubConBonos: 132000,
        ubSinBonos: 49000,
        autosVendidos: 1,
        ticketConBonos: 181000,
        ticketSinBonos: 163000,
      },
      {
        id: 30,
        fecha: "2026-10-28",
        agencia: "Nissan Cholula",
        asesor: "Ana López",
        financiera: "NR Finance",
        concepto: "Accesorios",
        facturado: 255000,
        ubConBonos: 186000,
        ubSinBonos: 69000,
        autosVendidos: 1,
        ticketConBonos: 255000,
        ticketSinBonos: 229000,
      },
      {
        id: 31,
        fecha: "2026-11-07",
        agencia: "Nissan San Manuel",
        asesor: "Jorge Ramírez",
        financiera: "Santander",
        concepto: "Servicios",
        facturado: 229000,
        ubConBonos: 167000,
        ubSinBonos: 62000,
        autosVendidos: 1,
        ticketConBonos: 229000,
        ticketSinBonos: 206000,
      },
      {
        id: 32,
        fecha: "2026-11-16",
        agencia: "Nissan Puebla",
        asesor: "Carlos Méndez",
        financiera: "NR Finance",
        concepto: "Bonos",
        facturado: 302000,
        ubConBonos: 221000,
        ubSinBonos: 81000,
        autosVendidos: 1,
        ticketConBonos: 302000,
        ticketSinBonos: 272000,
      },
      {
        id: 33,
        fecha: "2026-11-26",
        agencia: "Nissan Texmelucan",
        asesor: "Luis Herrera",
        financiera: "Banorte",
        concepto: "Accesorios",
        facturado: 173000,
        ubConBonos: 125000,
        ubSinBonos: 48000,
        autosVendidos: 1,
        ticketConBonos: 173000,
        ticketSinBonos: 156000,
      },
      {
        id: 34,
        fecha: "2026-12-04",
        agencia: "Nissan Cholula",
        asesor: "Fernanda Cruz",
        financiera: "BBVA",
        concepto: "Garantías",
        facturado: 268000,
        ubConBonos: 195000,
        ubSinBonos: 73000,
        autosVendidos: 1,
        ticketConBonos: 268000,
        ticketSinBonos: 241000,
      },
      {
        id: 35,
        fecha: "2026-12-15",
        agencia: "Nissan Puebla",
        asesor: "Ana López",
        financiera: "NR Finance",
        concepto: "Accesorios",
        facturado: 311000,
        ubConBonos: 227000,
        ubSinBonos: 84000,
        autosVendidos: 1,
        ticketConBonos: 311000,
        ticketSinBonos: 280000,
      },
      {
        id: 36,
        fecha: "2026-12-27",
        agencia: "Nissan San Manuel",
        asesor: "Jorge Ramírez",
        financiera: "Santander",
        concepto: "Bonos",
        facturado: 236000,
        ubConBonos: 171000,
        ubSinBonos: 65000,
        autosVendidos: 1,
        ticketConBonos: 236000,
        ticketSinBonos: 212000,
      },
    ];
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }

      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const handleDateApplyEvent = (event, picker) => {
    setLoading(true);

    setTimeout(() => {
      setFilters({
        startDate: picker.startDate.format("YYYY-MM-DD"),
        endDate: picker.endDate.format("YYYY-MM-DD"),
      });
      setLoading(false);
    }, 250);
  };

  const filteredData = useMemo(() => {
    const start = Moment(filters.startDate).startOf("day");
    const end = Moment(filters.endDate).endOf("day");

    const result = allDemoData.filter((item) => {
      const fecha = Moment(item.fecha, "YYYY-MM-DD");
      return fecha.isBetween(start, end, null, "[]");
    });

    return result;
  }, [allDemoData, filters]);

  useEffect(() => {
    if (!loading && filteredData.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin resultados",
        text: "No hay datos disponibles para el rango seleccionado.",
      });
    }
  }, [filteredData, loading]);

  const formatCurrency = (value) => {
    return `$${Number(value || 0).toLocaleString("es-MX", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };

  const textColor = () => {
    const isDarkMode =
      document.body.classList.contains("theme-default") ||
      document.body.getAttribute("data-bs-theme") === "dark";

    return isDarkMode ? "#e5e7eb" : "#111827";
  };

  const gridColor = () => {
    const isDarkMode =
      document.body.classList.contains("theme-default") ||
      document.body.getAttribute("data-bs-theme") === "dark";

    return isDarkMode ? "rgba(255,255,255,0.08)" : "#e5e7eb";
  };

  const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

  const monthlySeries = useMemo(() => {
    const facturado = new Array(12).fill(0);
    const ventas = new Array(12).fill(0);
    const ubConBonos = new Array(12).fill(0);
    const ubSinBonos = new Array(12).fill(0);
    const ticketConBonos = new Array(12).fill(0);
    const ticketSinBonos = new Array(12).fill(0);
    const operaciones = new Array(12).fill(0);

    filteredData.forEach((item) => {
      const monthIndex = Moment(item.fecha, "YYYY-MM-DD").month();

      facturado[monthIndex] += item.facturado;
      ventas[monthIndex] += item.autosVendidos;
      ubConBonos[monthIndex] += item.ubConBonos;
      ubSinBonos[monthIndex] += item.ubSinBonos;
      ticketConBonos[monthIndex] += item.ticketConBonos;
      ticketSinBonos[monthIndex] += item.ticketSinBonos;
      operaciones[monthIndex] += 1;
    });

    const ticketConBonosPromedio = ticketConBonos.map((item, idx) =>
      operaciones[idx] > 0 ? Math.round(item / operaciones[idx]) : 0
    );

    const ticketSinBonosPromedio = ticketSinBonos.map((item, idx) =>
      operaciones[idx] > 0 ? Math.round(item / operaciones[idx]) : 0
    );

    const acumuladoFacturado = [];
    facturado.reduce((acc, value) => {
      const total = acc + value;
      acumuladoFacturado.push(total);
      return total;
    }, 0);

    return {
      facturado,
      ventas,
      ubConBonos,
      ubSinBonos,
      ticketConBonosPromedio,
      ticketSinBonosPromedio,
      acumuladoFacturado,
    };
  }, [filteredData]);

  const rankingAgencias = useMemo(() => {
    const grouped = {};

    filteredData.forEach((item) => {
      if (!grouped[item.agencia]) {
        grouped[item.agencia] = 0;
      }
      grouped[item.agencia] += item.facturado;
    });

    return Object.entries(grouped)
      .map(([name, value]) => ({ name, y: value }))
      .sort((a, b) => b.y - a.y);
  }, [filteredData]);

  const rankingAsesores = useMemo(() => {
    const grouped = {};

    filteredData.forEach((item) => {
      if (!grouped[item.asesor]) {
        grouped[item.asesor] = 0;
      }
      grouped[item.asesor] += item.autosVendidos;
    });

    return Object.entries(grouped)
      .map(([name, value]) => ({ name, y: value }))
      .sort((a, b) => b.y - a.y);
  }, [filteredData]);

  const mixFinancieras = useMemo(() => {
    const grouped = {};

    filteredData.forEach((item) => {
      if (!grouped[item.financiera]) {
        grouped[item.financiera] = 0;
      }
      grouped[item.financiera] += 1;
    });

    return Object.entries(grouped).map(([name, value]) => ({
      name,
      y: value,
    }));
  }, [filteredData]);

  const mixConceptos = useMemo(() => {
    const grouped = {};

    filteredData.forEach((item) => {
      if (!grouped[item.concepto]) {
        grouped[item.concepto] = 0;
      }
      grouped[item.concepto] += item.facturado;
    });

    return Object.entries(grouped).map(([name, value]) => ({
      name,
      y: value,
    }));
  }, [filteredData]);

  const totalFacturado = filteredData.reduce((acc, item) => acc + item.facturado, 0);
  const autosVendidos = filteredData.reduce((acc, item) => acc + item.autosVendidos, 0);
  const totalUbConBonos = filteredData.reduce((acc, item) => acc + item.ubConBonos, 0);
  const totalUbSinBonos = filteredData.reduce((acc, item) => acc + item.ubSinBonos, 0);
  const promedioTicketConBonos =
    filteredData.length > 0
      ? Math.round(
          filteredData.reduce((acc, item) => acc + item.ticketConBonos, 0) /
            filteredData.length
        )
      : 0;
  const promedioTicketSinBonos =
    filteredData.length > 0
      ? Math.round(
          filteredData.reduce((acc, item) => acc + item.ticketSinBonos, 0) /
            filteredData.length
        )
      : 0;

  const baseChartOptions = {
    credits: { enabled: false },
    title: { text: null },
    chart: {
      backgroundColor: "transparent",
      style: {
        fontFamily: "inherit",
      },
    },
    legend: {
      itemStyle: {
        color: textColor(),
      },
    },
    xAxis: {
      labels: {
        style: {
          color: textColor(),
        },
      },
      lineColor: gridColor(),
      tickColor: gridColor(),
    },
    yAxis: {
      title: {
        text: null,
      },
      gridLineColor: gridColor(),
      labels: {
        style: {
          color: textColor(),
        },
      },
    },
    tooltip: {
      shared: true,
      backgroundColor: document.body.getAttribute("data-bs-theme") === "dark" ? "#1f2937" : "#ffffff",
      style: {
        color: textColor(),
      },
    },
  };

  const facturadoMesOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "column",
      height: 320,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: months,
    },
    series: [
      {
        name: "Facturado",
        data: monthlySeries.facturado,
      },
    ],
  };

  const ventasMesOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "spline",
      height: 320,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: months,
    },
    series: [
      {
        name: "Autos vendidos",
        data: monthlySeries.ventas,
      },
    ],
  };

  const ubMesOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "column",
      height: 320,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: months,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        borderRadius: 4,
      },
    },
    series: [
      {
        name: "UB con bonos",
        data: monthlySeries.ubConBonos,
      },
      {
        name: "UB sin bonos",
        data: monthlySeries.ubSinBonos,
      },
    ],
  };

  const ticketPromedioOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "areaspline",
      height: 320,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: months,
    },
    series: [
      {
        name: "Ticket con bonos",
        data: monthlySeries.ticketConBonosPromedio,
      },
      {
        name: "Ticket sin bonos",
        data: monthlySeries.ticketSinBonosPromedio,
      },
    ],
  };

  const agenciasOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "bar",
      height: 340,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: rankingAgencias.map((item) => item.name),
    },
    series: [
      {
        name: "Facturación",
        data: rankingAgencias.map((item) => item.y),
      },
    ],
  };

  const asesoresOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "column",
      height: 340,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: rankingAsesores.map((item) => item.name),
    },
    series: [
      {
        name: "Ventas",
        data: rankingAsesores.map((item) => item.y),
      },
    ],
  };

  const financierasOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "pie",
      height: 340,
    },
    tooltip: {
      pointFormat: "<b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        innerSize: "55%",
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.percentage:.1f}%",
          style: {
            color: textColor(),
            textOutline: "none",
          },
        },
      },
    },
    series: [
      {
        name: "Participación",
        data: mixFinancieras,
      },
    ],
  };

  const conceptosOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "pie",
      height: 340,
    },
    tooltip: {
      pointFormat: "<b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.percentage:.1f}%",
          style: {
            color: textColor(),
            textOutline: "none",
          },
        },
      },
    },
    series: [
      {
        name: "Distribución",
        data: mixConceptos,
      },
    ],
  };

  const acumuladoOptions = {
    ...baseChartOptions,
    chart: {
      ...baseChartOptions.chart,
      type: "line",
      height: 320,
    },
    xAxis: {
      ...baseChartOptions.xAxis,
      categories: months,
    },
    series: [
      {
        name: "Facturación acumulada",
        data: monthlySeries.acumuladoFacturado,
      },
    ],
  };

  return (
    <div className="container-fluid">
      {loading ? (
        <div
          className="loader-data"
          style={{
            minHeight: "300px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div className="row">
          <div className="col-12">
            <h1 className="page-header mb-4">
              Facturado{" "}
              <small>Dashboard con datos simulados para presentación</small>
            </h1>
          </div>

          <div className="col-12 mb-4">
            <div className="d-flex flex-wrap align-items-center gap-2">
              <DateRangePicker
                initialSettings={{
                  startDate: Moment(filters.startDate),
                  endDate: Moment(filters.endDate),
                  locale: {
                    format: "YYYY-MM-DD",
                    separator: " - ",
                    applyLabel: "Aplicar",
                    cancelLabel: "Cancelar",
                    fromLabel: "Desde",
                    toLabel: "Hasta",
                    customRangeLabel: "Personalizado",
                    weekLabel: "S",
                    daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
                    monthNames: [
                      "Enero",
                      "Febrero",
                      "Marzo",
                      "Abril",
                      "Mayo",
                      "Junio",
                      "Julio",
                      "Agosto",
                      "Septiembre",
                      "Octubre",
                      "Noviembre",
                      "Diciembre",
                    ],
                    firstDay: 1,
                  },
                  ranges: {
                    Hoy: [Moment(), Moment()],
                    "Últimos 7 días": [Moment().subtract(6, "days"), Moment()],
                    "Últimos 30 días": [Moment().subtract(29, "days"), Moment()],
                    "Este mes": [Moment().startOf("month"), Moment().endOf("month")],
                    "Este año": [Moment().startOf("year"), Moment().endOf("year")],
                  },
                }}
                onApply={handleDateApplyEvent}
              >
                <button
                  type="button"
                  className="btn btn-secondary btn-sm d-inline-flex align-items-center"
                >
                  <span>
                    {filters.startDate && filters.endDate
                      ? `${filters.startDate} - ${filters.endDate}`
                      : "Selecciona un rango"}
                  </span>
                  <i className="fa fa-chevron-down ms-2 fs-8px"></i>
                </button>
              </DateRangePicker>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 mb-3">
            <Card className="h-100">
              <CardHeader>Ventas x concepto</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-1">{filteredData.length}</div>
                <div className="text-muted black-text">Registros en el rango</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-3 col-md-6 mb-3">
            <Card className="h-100">
              <CardHeader>Autos vendidos</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-1">{autosVendidos}</div>
                <div className="text-muted black-text">Operaciones simuladas</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-3 col-md-6 mb-3">
            <Card className="h-100">
              <CardHeader>Ticket sin bonos</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-1">
                  {formatCurrency(promedioTicketSinBonos)}
                </div>
                <div className="text-muted black-text">Promedio del periodo</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-3 col-md-6 mb-3">
            <Card className="h-100">
              <CardHeader>Ticket con bonos</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-1">
                  {formatCurrency(promedioTicketConBonos)}
                </div>
                <div className="text-muted black-text">Promedio del periodo</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 col-md-6 mb-3">
            <Card className="h-100">
              <CardHeader>UB con bonos</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-1">
                  {formatCurrency(totalUbConBonos)}
                </div>
                <div className="text-muted black-text">Acumulado en el rango</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 col-md-6 mb-3">
            <Card className="h-100">
              <CardHeader>UB sin bonos</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-1">
                  {formatCurrency(totalUbSinBonos)}
                </div>
                <div className="text-muted black-text">Acumulado en el rango</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-8 mb-3">
            <Card className="h-100">
              <CardHeader>Facturado por mes</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-3">
                  {formatCurrency(totalFacturado)}
                </div>
                <Chart options={facturadoMesOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-4 mb-3">
            <Card className="h-100">
              <CardHeader>Autos vendidos por mes</CardHeader>
              <CardBody>
                <div className="h4 fw-100 black-text mb-3">{autosVendidos}</div>
                <Chart options={ventasMesOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 mb-3">
            <Card className="h-100">
              <CardHeader>UB por mes</CardHeader>
              <CardBody>
                <Chart options={ubMesOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 mb-3">
            <Card className="h-100">
              <CardHeader>Ticket promedio mensual</CardHeader>
              <CardBody>
                <Chart options={ticketPromedioOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 mb-3">
            <Card className="h-100">
              <CardHeader>Ranking por agencia</CardHeader>
              <CardBody>
                <Chart options={agenciasOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 mb-3">
            <Card className="h-100">
              <CardHeader>Ranking por asesor</CardHeader>
              <CardBody>
                <Chart options={asesoresOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 mb-3">
            <Card className="h-100">
              <CardHeader>Mix por financiera</CardHeader>
              <CardBody>
                <Chart options={financierasOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-6 mb-3">
            <Card className="h-100">
              <CardHeader>Distribución por concepto</CardHeader>
              <CardBody>
                <Chart options={conceptosOptions} />
              </CardBody>
            </Card>
          </div>

          <div className="col-xl-12 mb-3">
            <Card className="h-100">
              <CardHeader>Facturación acumulada</CardHeader>
              <CardBody>
                <Chart options={acumuladoOptions} />
              </CardBody>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateChart;